import { combineReducers } from 'redux';
import { productReducer } from './productReducer'
import { purchaseReducer } from './purchaseReducer'
import { shopReducer } from './shopReducer'
import { inventoryReducer } from './inventoryReducer'
import { saleReducer } from './saleReducer'
import { quoteReducer } from './quoteReducer'
import { clientReducer } from './clientReducer'
import { savReducer } from './savReducer';
import { returnReducer } from './returnReducer';
import { returnSaleReducer } from './returnSaleReducer';
import { commercialReaReducer } from './commercialReaReducer';
import { commercialStockReducer } from './commercialStockReducer';
import { commercialReturnReducer } from './commercialReturnReducer';

import { inventoryStateReducer } from './inventoryStateReducer'
import requestReducer, {initialState as requestINIT } from './requestState/requestReducer'
import { arrivageReducer } from './arrivageReducer';
import { demandReducer } from './demandReducer';
import { resaReducer } from './resaReducer';
import { resaDemandReducer } from './resaDemandReducer';
import { installReducer } from './installReducer';
import { saleCreditReducer } from './saleCreditReducer';
import { avoirReducer } from './avoirReducer';


export const initialState = {
    products:{},
    shops:{},
    stocks:{
        WAITING_DELIVERY:{},
        OCCASION:{},
        AVAILABLE:{},
        COMMERCIAL:{},
        PREPA:{},
        SAV:{},
        DEFECTIVE:{},
        LEASING:{},
        END_LEASING:{},
        OUT:{},
    },
    sales:{
        SALES : {},
        QUOTES : {},
        REAPPRO : {},
        REA_DRAFTS : {},
        DEVIS : {},
        ALL: {}
    },
    avoirs:{},
    clients:{},
    purchases:{},
    state: {},
    requestState:requestINIT,
};
export default combineReducers({
    products : productReducer,
    purchases : purchaseReducer,
    shops : shopReducer,
    stocks : inventoryReducer,
    sales : saleReducer,
    quotes: quoteReducer,
    clients : clientReducer,
    sav: savReducer,
    returns: returnReducer,
    returnSales: returnSaleReducer,
    commercialReas: commercialReaReducer,
    commercialStocks: commercialStockReducer,
    commercialReturns: commercialReturnReducer,
    arrivages: arrivageReducer,
    demands: demandReducer,
    resas: resaReducer,
    resaDemands: resaDemandReducer,
    installs: installReducer,
    credits: saleCreditReducer,
    state : inventoryStateReducer,
    requestState : requestReducer,
    avoirs : avoirReducer,
});

